module.exports = __webpack_public_path__ + "static/media/img-1.5ce5ffe3.jpg";